/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { StyleSheet } from 'react-native-unistyles';
import { pd } from '@airasia-phoenix/react-native/tokens';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: pd.sys.colour.bg_primary.toString(),
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: pd.ref.space.spacing40.px,
    width: '100%',
    alignSelf: 'center',
  },
});

export default styles;
